// Template: resources/views/_components/trial-bar.blade.php

export default {

    name: "Pricing",

    data() {
        return {
            annualBilling: true
        }
    }
};
